module.exports = require('./helpers/bundle-url').getBundleURL('HuwXZ') + "logo-dark.eefe0b7f.svg";